import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * Waiver Schema
 * Represents a waiver/release form for players
 */
export const WaiverSchema = z.object({
  _id: objectId,
  name: z.string().default(''),
  title: z.string().default(''),
  html: z.string().default(''),
  organization: objectId,
  finalized: z.boolean().default(false),
  ...timestampFields,
});

export type Waiver = z.infer<typeof WaiverSchema>;

export const waiverMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  name: { label: 'Name', editable: true },
  title: { label: 'Title', editable: true },
  html: { label: 'HTML Content', editable: true },
  organization: { ref: 'Organization', label: 'Organization' },
  finalized: { label: 'Finalized', editable: true },
  created: { hidden: true },
  updated: { hidden: true },
};
